/* eslint-disable import/no-cycle */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-extraneous-dependencies */
import { Button, Drawer, Heading, MAGNETIC_TOKENS, css, format, utils } from '@appd/uik';
import { DateTime } from 'luxon';
import { useState } from 'react';
import { BACKGROUND_SHAPES } from './BACKGROUND_SHAPES';
import { Carousel } from './Carousel/Carousel';
import { LOGO_ICON } from './LOGO_ICON';
import { MedalTally } from './MedalTally/MedalTally';
import { Spacer } from './Spacer';

/**
 * DASHUI-9592
 *
 * Likely this code will be deleted after August 11, 2024 (end of Olympics).
 *
 * https://www.figma.com/design/zJpIVMGRmvEuPbSYRvZ7BS/Olympics-dashboard?node-id=64-50022&t=AhHPaSm7lHDZjcC7-1
 */
export const LiveNewsDrawer = () => {
  const [open, setOpen] = useState(false);

  css.RENDERER.renderFont('Paris2024-Variable', ['assets/paris2024/Paris2024-Variable.ttf'], {
    fontDisplay: 'fallback',
  });

  const now = DateTime.now();

  return (
    utils.useFontsReady() && (
      <>
        <Button
          onClick={() => setOpen(!open)}
          className={{
            ':focus-visible, :hover': { backgroundColor: '#858BEE' },
            '> svg': { flexShrink: 0 },
            backgroundColor: '#474398',
            height: 31,
            borderRadius: MAGNETIC_TOKENS.SPACING[1],
            // As measured on Figma
            ...{
              gap: 11.14,
              paddingLeft: 11.55,
              // Figma says `20` but it looks asymmetrical, so I changed it to `11.55`.
              paddingRight: 11.55 ?? 20,
            },
          }}
        >
          {LOGO_ICON}
          <span
            className={css({
              color: 'white',
              fontFamily: 'Paris2024-Variable',
              fontSize: 16,
              // Too thick in Chrome
              fontWeight: 450 ?? 550,
              lineHeight: '20px',
              ...MAGNETIC_TOKENS.TYPOGRAPHY.ELLIPSES.END,
            })}
          >
            {now < START_DATE
              ? `${DAYS(Math.ceil(START_DATE.diff(now, 'days').days))} until Paris 2024`
              : now > END_DATE
              ? `${DAYS(1 + Math.floor(now.diff(END_DATE, 'days').days))} since Paris 2024`
              : `Day ${1 + Math.floor(now.diff(START_DATE, 'days').days)} | Paris 2024`}
          </span>
        </Button>

        {open && (
          <Drawer
            className={{ paddingInline: 20 }}
            onClose={() => setOpen(false)}
            title=""
            subtitle={
              <div
                className={css({
                  marginTop: -4 /* gap */ - 16 /* Drawer padding */ + 7 /* Figma's padding */,
                  marginLeft: -24 /* Drawer padding */ + 15 /* Figma's padding */,
                  marginBottom: -16 /* Drawer padding */,
                  display: 'flex',
                  gap: MAGNETIC_TOKENS.SPACING[2],
                })}
              >
                <img
                  src="assets/paris2024/logo.png"
                  alt="Paris 2024 Olympics Logo"
                  className={css({
                    paddingTop: 6.2,
                    paddingBottom: 9.488,
                    paddingInline: 14,
                    boxSizing: 'border-box',
                    width: 84,
                  })}
                />
                <div>
                  <Heading
                    size="PRIMARY"
                    className={{
                      marginTop: 9,
                      color: '#373C42',
                      fontFamily: 'Paris2024-Variable',
                      // Too thick in Chrome
                      fontWeight: 660 ?? 760,
                    }}
                  >
                    Paris Olympics 2024
                  </Heading>
                  <div
                    className={css({
                      color: MAGNETIC_TOKENS.COLORS.DEFAULT_TEXT_MEDIUM,
                      fontFamily: 'Paris2024-Variable',
                      fontSize: 14,
                      // Too thick in Chrome
                      fontWeight: 250 ?? 350,
                      lineHeight: '20px',
                    })}
                  >
                    Catch all the latest happenings from Paris Olympics 2024
                  </div>
                </div>
              </div>
            }
          >
            {BACKGROUND_SHAPES}

            <Carousel />

            <Spacer height={21.6} />

            <MedalTally />
          </Drawer>
        )}
      </>
    )
  );
};

LiveNewsDrawer.Carousel = Carousel;

LiveNewsDrawer.DAYS = format.message`${['0 days', '1 day', '$0 days']}`.description(
  'Singular/plural for how many "days" elapsed or until the Olympics.',
);

LiveNewsDrawer.DEBUG = false;

/** August 11, 2024 at 12:00 AM GMT+2 */
LiveNewsDrawer.END_DATE = DateTime.fromObject(
  { year: 2024, month: 8, day: 11 /* Day after closing ceremony */ + 1 },
  { zone: 'Europe/Paris' },
);

LiveNewsDrawer.MedalTally = MedalTally;

/** July 26, 2024 at 12:00 AM GMT+2 */
LiveNewsDrawer.START_DATE = DateTime.fromObject(
  { year: 2024, month: 7, day: /* Day of opening ceremony */ 26 },
  { zone: 'Europe/Paris' },
);

LiveNewsDrawer.clearCache = () => {
  Carousel.CACHE.clear();

  MedalTally.CACHE.clear();
};

(globalThis as any).LiveNewsDrawer = LiveNewsDrawer;

const { DAYS, START_DATE, END_DATE } = LiveNewsDrawer;
